export default {
  getMemorials: state => state.memorials,
  getChurchMemorials: state => state.churchMemorials,
  getCondition: state => state.condition,
  getSearchType: state => state.condition.searchType,
  getMemorialType: state => state.memorialType,
  getChurchNo: state => state.churchNo,
  getDetail: state => state.detail,
  getHistoryList: state => state.historyList,

  getAliveList: state => state.aliveList,
  getAliveDetail: state => state.aliveDetail,

  getBackground: state => state.backgroundList,
  getFrame: state => state.frameList,
  getStepOne: state => state.register.step1,
  getStepTwo: state => state.register.step2,
  getStepThree: state => state.register.step3,
  getRegister: state => state.register,
  getCommentList: state => state.memorialCommentList,
  getCommentCondition: state => state.commentCondition,
  getAliveCondition: state => state.aliveCondition,
  getChurchCondition: state => state.churchCondition,
  getHistoryCondition: state => state.historyCondition,
  getIsMore: state => state.isMore,
  getPageInfo: state => state.pageInfo,

  getAnniversaryList: state => state.anniversaryList,
  getBackgroundPreViewImage: state => state.backgroundPreViewImage
};
